import {useCallback} from 'react';

import {ADD_TEEN_EVENTS} from '@/app/auth/events/AddTeenEvents';
import {PULLING_CREATE_TEEN} from '@/app/auth/events/PullingCreateTeenEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {IUserTrack, OriginType} from '@/services';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewAddKidCreatingKidAccount = useCallback(() => {
    trackEvent(PULLING_CREATE_TEEN.VIEW_ADD_KID_CREATING_KID_ACCOUNT, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  const trackViewAddKidConfirmationError = useCallback(
    (origin: OriginType) => {
      trackEvent(PULLING_CREATE_TEEN.VIEW_ADD_KID_CONFIRMATION_ERROR, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        origin,
      });
    },
    [trackEvent],
  );

  const trackViewCreateTeenWithTeenData = useCallback(
    (userTrack: IUserTrack) => {
      trackEvent(ADD_TEEN_EVENTS.VIEW_CREATE_TEEN_WITH_TEEN_DATA, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        FamilyMember: {
          id: userTrack?.uuid,
          email: userTrack?.email,
          phone: userTrack?.phone,
          role: userTrack?.type,
        },
      });
    },
    [trackEvent],
  );

  return {
    trackViewAddKidCreatingKidAccount,
    trackViewAddKidConfirmationError,
    trackViewCreateTeenWithTeenData,
  };
};
